import Yup from '@utils/Yupi18n';

const RegistrarPPM = Yup.object().shape({
  NombreCompleto: Yup.string()
    .min(3)
    .max(80)
    .required('Nombre Completo es requerido')
    .label('Nombre Completo'),
  idResponsabilidad: Yup.number()
    .oneOf([0, 1, 2])
    .required('Responsabilidad es requerido')
    .label('Responsabilidad'),
  Ubicacion: Yup.string().required('Ubicación es requerida').label('Ubicación'),
  imageName: Yup.string().required('Nombre de la imagen es requerido').label('Nombre de la Imagen'),
  files: Yup.array()
    .min(1)
    .max(1)
    .of(
      Yup.object().shape({
        file: Yup.string().required('Imagen es requerida'),
      })
    )
    .required('Debe incluir exactamente una imagen'),
});

const BannerPPM = Yup.object().shape({
  title: Yup.string()
    .min(3)
    .max(40)
    .label('Título'),
  description: Yup.string().min(3).label('Descripción'),
  files: Yup.array()
    .min(1)
    .max(1)
    .of(
      Yup.object().shape({
        file: Yup.string().required('Imagen es requerida'),
      })
    )
    .required('Debe incluir exactamente una imagen'),
  socialNetworks: Yup.array().of(
    Yup.object().shape({
      SocialNetworksLink: Yup.string(),
      SocialNetworksType: Yup.number(),
    })
  ),
});

const socialNetworks = Yup.object().shape({
  socialNetworksType: Yup.number().required("Medio es requerido"),
  socialNetworksLink: Yup.string()
    .when('socialNetworksType', {
      is: 4,
      then: (item) => item.email("Debe ser un correo electrónico válido").required("Correo es requerido"),
      otherwise: (schema) => schema
        .matches(/^https?:\/\//, "El link debe comenzar con http:// o https://")
        .required("Link es requerido"),
    }),
  textButton: Yup.string().min(2).max(20).required("Texto en botón es requerido"),
});

const GalleryPPM = Yup.object().shape({
  idEvento: Yup.number().min(1, 'Debes seleccionar al menos un evento'),
  files: Yup.array()
    .min(1, 'Debe incluir al menos una imagen')
    .max(50, 'No puede incluir más de 50 imágenes')
    .of(
      Yup.object().shape({
        file: Yup.string().required('El archivo es requerido'),
        fileNameImg: Yup.string().required('El nombre de la imagen es requerido'),
        type: Yup.string().oneOf(['img'], 'Tipo inválido').required('El tipo es requerido'),
      })
    )
    .required('Debe incluir al menos una imagen'),
});



export { RegistrarPPM, BannerPPM, socialNetworks, GalleryPPM };
